import { FC } from 'react';
import { ReactNodeSingleOrArray } from 'shared/types';

import styles from './styles.module.scss';

interface ILayoutProps {
  children?: ReactNodeSingleOrArray;
}

export const LayoutNotFound: FC<ILayoutProps> = ({ children }) => {
  return (
    <div className={styles['layout']}>
      <div className={styles['container']}>
        {/* <HeaderMain /> */}
        {children}
      </div>
    </div>
  );
};
